import {
  DELETE_COMPANY_WATCHER,
  DELETE_USER_WATCHER,
  GET_COMPANIES_INFO_WATCHER,
  GET_COMPANIES_SAVE_WATCHER,
  GET_COMPANY_WATCHER,
  STATUS_COMPANY_WATCHER,
  USERS_COMPANY_WATCHER,
  USERS_SA_SWITCH_WATCHER,
  GET_USERS_WATCHER,
  VALIDATE_VISMA_PEOPLE_INFO_WATCHER,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER
} from "./constants"
import { all, call, cancelled, put, takeLatest } from "redux-saga/effects"
import {
  deleteCompanyFailed,
  deleteCompanySuccess,
  getCompaniesInfoSuccess,
  getCompanySuccess,
  saveCompanyFailed,
  saveCompanySuccess,
  usersCompanyFailed,
  usersCompanySuccess,
  usersCompanyWatcher,
  usersSASwitchFailed,
  usersSASwitchSuccess,
  getCompanyUsersSuccess,
  validateVismaPeopleInfoSuccess,
  validateVismaPeopleInfoFailed,
  validateVismaPeopleStructureSuccess,
  validateVismaPeopleStructureFailed,
} from "./actions"

import { LOCAL_TOKEN } from "../../../../utils/storage"
import { ROLE_COMPANY_SUPER_ADMIN } from "../../../../utils/constants"
import axios from "axios"
import { push } from "connected-react-router"
import { updateSwitchUser } from "../../../../services/control-panel"

// import { returnMessage } from 'utils/catchError'

// Get Options
function getCompaniesOptionsApi(params) {
  const url = "companies/create"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Save company
function saveCompanyApi(params) {
  let url = "companies"
  let method = "POST"
  if (!isNaN(params.payload.company_id)) {
    url = `companies/${params.payload.company_id}`
    method = "PUT"
  }
  return axios.request({
    method,
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params.payload,
    url: `${process.env.API_URL + url}`,
  })
}

// Get company
function getCompanyApi(params) {
  const url = `companies/${params.payload.company_id}`
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Delete company
function deleteCompanyApi(params) {
  const url = `companies/${params.payload.company_id}`
  return axios.request({
    method: "DELETE",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Save company status
function statusCompanyApi(params) {
  const url = `companies/${params.payload.company_id}/update-switch`
  const method = "PUT"
  return axios.request({
    method,
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params.payload,
    url: `${process.env.API_URL + url}`,
  })
}

// Get company users
function usersCompanyApi(params) {
  const url = `companies/${params.payload.company_id}/users`
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

// Delete company administrator
export function deleteUserApi({ company_id, user_id }) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${company_id}/users/${user_id}`,
  })
}

function validateVismaPeopleInfoApi(params) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}visma-people/validate-sync`,
    data: params,
  })
}

function validateVismaPeopleStructureApi(params) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}visma-people/validate-structures`,
    data: params,
  })
}

export function* deleteUserSaga(action) {
  try {
    const data = yield call(deleteUserApi, action.payload)
    returnMessage(data)
    yield put(usersCompanyWatcher({ company_id: action.payload.company_id }))
  } catch (error) {
    returnMessage(error)
  }
}

export function* getCompaniesInfoSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(getCompaniesOptionsApi, params)
    if (status === 200) {
      yield put(getCompaniesInfoSuccess(data))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* saveCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(saveCompanyApi, params)
    yield put(saveCompanySuccess(data.data))
    returnMessage(data)
    if (isNaN(params.payload.company_id)) {
      yield put(push("/companies"))
    }
  } catch (e) {
    returnMessage(e)
    yield put(saveCompanyFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const [statusApi] = yield all([
      call(getCompanyApi, params),
      call(getCompaniesInfoSaga, params),
    ])
    const result = statusApi
    returnMessage(result)
    yield put(getCompanySuccess(result.data.data))
  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}
export function* getCompanyUsersSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token

   const data= yield all([
    call(usersCompanySaga, params)
  ])

  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* deleteCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(deleteCompanyApi, params)
    if (status === 200) {
      message.success("Empresa eliminada correctamente.", 5)
      yield put(deleteCompanySuccess(data.data))
      yield put(push("/companies"))
    }
  } catch (e) {
    returnMessage(e)
    yield put(deleteCompanyFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* statusCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(statusCompanyApi, params)
    returnMessage(data)
  } catch (e) {
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* usersCompanySaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const [statusApi] = yield all([call(usersCompanyApi, params)])
    const result = statusApi
    returnMessage(result)
    yield put(usersCompanySuccess(result.data.data))
  } catch (e) {
    returnMessage(e)
    yield put(usersCompanyFailed({}))
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* usersSASwitchSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const data = yield call(updateSwitchUser, params.payload)
    const dataUser = data.data.data.result.user
    const listUsers = params.payload.users
    let userRoles = []
    dataUser.roles?.map((row) => userRoles.push(row.id))
    const newsListUsers = listUsers.map((e) => {
      if (e.id === dataUser.id) {
        e = dataUser
        e.isCompanySuperAdmin = userRoles.includes(ROLE_COMPANY_SUPER_ADMIN)
      }
      return e
    })
    yield put(usersCompanySuccess(newsListUsers))
    yield put(usersSASwitchSuccess())
    returnMessage(data)
  } catch (e) {
    yield put(usersSASwitchFailed())
    returnMessage(e)
  } finally {
    if (yield cancelled()) {
      yield put(usersSASwitchFailed())
      cancelSource.cancel()
    }
  }
}

export function* validateVismaPeopleInfoSaga(action) {
  try {
    const { data } = yield call(validateVismaPeopleInfoApi, action.payload)
    yield put(validateVismaPeopleInfoSuccess(data))
  } catch (error) {
    console.log(error)
    yield put(validateVismaPeopleInfoFailed())
  }
}

export function* validateVismaPeopleStructureSaga(action) {
  try {
    const { data } = yield call(validateVismaPeopleStructureApi, action.payload)
    yield put(validateVismaPeopleStructureSuccess(data))
  } catch (error) {
    console.log(error)
    yield put(validateVismaPeopleStructureFailed())
  }
}

export default function* formSaga() {
  yield takeLatest(GET_COMPANIES_INFO_WATCHER, getCompaniesInfoSaga)
  yield takeLatest(GET_COMPANIES_SAVE_WATCHER, saveCompanySaga)
  yield takeLatest(GET_COMPANY_WATCHER, getCompanySaga)
  yield takeLatest(GET_USERS_WATCHER, getCompanyUsersSaga)
  yield takeLatest(DELETE_COMPANY_WATCHER, deleteCompanySaga)
  yield takeLatest(STATUS_COMPANY_WATCHER, statusCompanySaga)
  yield takeLatest(USERS_COMPANY_WATCHER, usersCompanySaga)
  yield takeLatest(USERS_SA_SWITCH_WATCHER, usersSASwitchSaga)
  yield takeLatest(DELETE_USER_WATCHER, deleteUserSaga)
  yield takeLatest(VALIDATE_VISMA_PEOPLE_INFO_WATCHER, validateVismaPeopleInfoSaga)
  yield takeLatest(VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER, validateVismaPeopleStructureSaga)
}
